export default __webpack_public_path__ + "static/media/LoopCropVert.832f77be.gif";